// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"c0d40e7f","669":"bbd6222f","680":"846f6c77"}[chunkId] + ".chunk.js";
};